/* eslint-disable max-len */
export const SCREEN_ID_HOMEPAGE = 'Homepage';
export const SCREEN_ID_LISTINGS = 'Listings';
export const SCREEN_ID_BROKER_LISTINGS_IFRAME_VIEW = 'Listings Iframe';
export const SCREEN_ID_LISTINGS_MAP = 'Listings Map';
export const SCREEN_ID_FEED = 'Feed';
export const SCREEN_ID_FEED_CATEGORY_MAP = 'Feed - Category Map';
export const SCREEN_ID_FEED_CATEGORY = 'Feed - Category List';
export const SCREEN_ID_SEARCH_FILTERS = 'Search Filters';
export const SCREEN_ID_ADDRESS_SEARCH = 'Address Search';
export const SCREEN_ID_LISTING = 'Listing';
export const SCREEN_ID_LISTING_PHOTOS = 'Listing Photos';
export const SCREEN_ID_LISTING_MAP = 'Listing Map';
export const SCREEN_ID_LISTING_NEW_HOMES = 'Listing New Homes';
export const SCREEN_ID_LISTING_PREQUALIFICATION = 'Listing Prequalification';
export const SCREEN_ID_LISTING_CHOOSE_TOUR_TIME = 'Listing Choose Tour Time';
export const SCREEN_ID_LISTING_REQUEST_TOUR_EMAIL = 'Listing Request Tour Email';
export const SCREEN_ID_LISTING_SELF_TOUR_MULTI_FAMILY = 'Listing - Self Tour Multi Family';
export const SCREEN_ID_APARTMENT = 'Apartment';
export const SCREEN_ID_APARTMENT_PHOTOS = 'Apartment Photos';
export const SCREEN_ID_APARTMENT_MAP = 'Apartment Map';
export const SCREEN_ID_HOUSEHOLD_CONFIRM_IN_PERSON_TOUR = 'Household Confirm In-Person Tour';
export const SCREEN_ID_HOUSEHOLD_CONFIRM_MOVE_IN = 'Household Confirm Move In';
export const SCREEN_ID_HOUSEHOLD_ADD_LEAD_RENTER_EMAIL = 'Household Add Lead Renter Email';
export const SCREEN_ID_HOUSEHOLD_INVITE_GUARANTOR = 'Household Invite Guarantor';
export const SCREEN_ID_HOUSEHOLD_INVITE_GUARANTOR_SENT = 'Household Invite Guarantor Sent';
export const SCREEN_ID_HOUSEHOLD_COLLECT_ROOMMATE_COUNT = 'Household Collect Roommate Count';
export const SCREEN_ID_HOUSEHOLD_BUYER_SIDE_AGENT = 'Household Buyer Side Agent';
export const SCREEN_ID_HOUSEHOLD_COLLECT_LEAD_RENTER_INFO = 'Household Add Lead Renter Info';
export const SCREEN_ID_HOUSEHOLD_COLLECT_ROOMMATE_INFO = 'Household Collect Roommate Info';
export const SCREEN_ID_HOUSEHOLD_ROOMMATE_INVITES_SENT = 'Household Roommate Invite Links Sent';
export const SCREEN_ID_PREQUAL_FORM_START_PAGE = 'Prequal Form Start Page';
export const SCREEN_ID_PREQUAL_COMPLETED_REQUEST_TOUR = 'Prequal Completed Request Tour';
export const SCREEN_ID_APPLICATION_STARTER = 'Application Starter';
export const SCREEN_ID_APPLICATION_START = 'Application Start';
export const SCREEN_ID_APPLICATION_FORM = 'Application Form';
export const SCREEN_ID_APPLICATION_FORM_CONFIRMATION = 'Application Form Confirmation';
export const SCREEN_ID_APPLICATION_SUBMITTED = 'Application Submitted';
export const SCREEN_ID_APPLICATION_PAID = 'Application Paid';
export const SCREEN_ID_APPLICATION_SUBMISSSION_PAID = 'Application Submission Paid';
export const SCREEN_ID_SECURITY_DEPOSIT_PAYMENT = 'Security Deposit Payment';
export const SCREEN_ID_RENTER_PROFILE_SUBMITTED = 'Renter Profile Submitted';
export const SCREEN_ID_LISTING_APARTMENT_LOCATOR = 'Listing Apartment Locator';
export const SCREEN_ID_TOURS = 'Tours';
export const SCREEN_ID_TOURS_SAVED = 'Tours - Saved';
export const SCREEN_ID_TOURS_COMPLETED = 'Tours - Completed';
export const SCREEN_ID_TOUR_CONFIRM_MOVE_IN = 'Tour Confirm: Move In';
export const SCREEN_ID_TOUR_CONFIRM_AVAILABLE_DATE = 'Tour Confirm: Available Date';
export const SCREEN_ID_TOUR_CONFIRM_MAX_LEASE_MONTHS = 'Tour Confirm: Max Lease Months';
export const SCREEN_ID_TOUR_CONFIRM_FIRST_TIME = 'Tour Confirm';
export const SCREEN_ID_TOUR_CONFIRM_PHONE = 'Tour Confirm: Phone';
export const SCREEN_ID_TOUR_VERIFY_PHONE = 'Tour Verify: Phone';
export const SCREEN_ID_TOUR_CANCELLATION = 'Tour Cancellation';
export const SCREEN_ID_TOUR_REVIEW = 'Tour Review';
export const SCREEN_ID_BOOKMARKS = 'Bookmarks';
export const SCREEN_ID_TOUR_SCHEDULE = 'Tour Schedule';
export const SCREEN_ID_FAQ = 'FAQ';
export const SCREEN_ID_FAQ_APPLICATION = 'FAQ Application';
export const SCREEN_ID_FAQ_MOVE_IN_DATE = 'FAQ Move-in Date';
export const SCREEN_ID_MAINTENANCE = 'Maintenance';
export const SCREEN_ID_LOGIN = 'Login';
export const SCREEN_ID_USER_TOKEN_LOGIN = 'User Token Login';
export const SCREEN_ID_LOGOUT = 'Logout';
export const SCREEN_ID_ROOMMATE_SIGNUP = 'Roommate Signup';
export const SCREEN_ID_RESET_PASSWORD = 'Reset Password';
export const SCREEN_ID_RESET_PASSWORD_VALIDATE_CODE = 'Reset Password Validate Code';
export const SCREEN_ID_RESET_PASSWORD_CONFIRM = 'Reset Password Confirm';
export const SCREEN_ID_NOT_FOUND = 'Not Found';
export const SCREEN_ID_REFER_RENTER = 'Refer Renter';
export const SCREEN_ID_USER_MAP_AREA = 'User Map Area';
export const SCREEN_ID_RENTER_PROFILE = 'Renter Profile';
export const SCREEN_ID_RENTER_PROFILE_PUBLIC = 'Renter Application (Agent View)';
export const SCREEN_ID_JOIN_SUNROOM_CLUB = 'Join Sunroom Club';
export const SCREEN_ID_JOIN_SUNROOM_CLUB_MEMBERSHIP_PAID = 'Sunroom Club Membership Paid';
export const SCREEN_ID_JOIN_SUNROOM_CLUB_QUESTIONNAIRE = 'Sunroom Club Questionnaire';
export const SCREEN_ID_JOIN_SUNROOM_CLUB_THANK_YOU = 'Join Sunroom Club Thank You';
export const SCREEN_ID_JOIN_SUNROOM_SELECT_MARKETING = 'Sunroom Select Marketing';
export const SCREEN_ID_CONNECT_BANK_ACCOUNT_START = 'Connect Bank Account Start';
export const SCREEN_ID_CONNECT_BANK_ACCOUNT_FORM = 'Connect Bank Account Form';
export const SCREEN_ID_PLAID_OAUTH = 'Plaid Oauth';
export const SCREEN_ID_BUYER_SIDE_AGENT_SIGNUP = 'Buyer Side Agent Sign Up';
export const SCREEN_ID_APPLY = 'Apply';

export const SCREEN_ID_SWITCH_TO_APARTMENTS = 'Onboarding - Switch To Apartments';
export const SCREEN_ID_ONBOARDING_PROPERTY_TYPES = 'Onboarding: Property Types';
export const SCREEN_ID_ONBOARDING_BEDROOMS = 'Onboarding: Bedrooms';
export const SCREEN_ID_ONBOARDING_BEDROOMS_MULTI = 'Onboarding: Bedrooms (Select Multiple)';
export const SCREEN_ID_ONBOARDING_PROPERTY_PRICES = 'Onboarding: Property Prices';
export const SCREEN_ID_ONBOARDING_PROPERTY_PRICES_RANGE = 'Onboarding: Property Prices Range';
export const SCREEN_ID_ONBOARDING_LEASE_SITUATION = 'Onboarding: Lease Situation';
export const SCREEN_ID_ONBOARDING_LEASE_TERM = 'Onboarding: Lease Term';
export const SCREEN_ID_ONBOARDING_MOVE_IN_DATE = 'Onboarding: Move In Date';
export const SCREEN_ID_ONBOARDING_PET_COUNT = 'Onboarding: Pet Count';
export const SCREEN_ID_ONBOARDING_PETS = 'Onboarding: Pets';
export const SCREEN_ID_ONBOARDING_MARKET = 'Onboarding: Market';
export const SCREEN_ID_ONBOARDING_LOCATION = 'Onboarding: Location';
export const SCREEN_ID_ONBOARDING_START_TOURING = 'Onboarding: Start Touring';
export const SCREEN_ID_ONBOARDING_NAME = 'Onboarding: Name';
export const SCREEN_ID_ONBOARDING_EMAIL = 'Onboarding: Email';
export const SCREEN_ID_ONBOARDING_PHONE = 'Onboarding: Phone';
export const SCREEN_ID_ONBOARDING_PASSWORD = 'Onboarding: Password';
export const SCREEN_ID_ONBOARDING_LAUNDRY = 'Onboarding: Laundry';
export const SCREEN_ID_ONBOARDING_ROOMMATE_COUNT = 'Onboarding: Roommate Count';
export const SCREEN_ID_ONBOARDING_CREDIT_SCORE = 'Onboarding: Credit Score';
export const SCREEN_ID_PARTNERS_LISTINGS_SCRAPER = 'Admin Partners Listings Scraper';

export const SCREEN_ID_ADMIN_HOME = 'Admin Home';
export const SCREEN_ID_ADMIN_PARTNERS_REVIEW = 'Admin Partners Review';
export const SCREEN_ID_ADMIN_TOURS_PENDING = 'Tours Admin - Pending';
export const SCREEN_ID_ADMIN_TOURS_PENDING_CONFIRMATION = 'Tours Admin - Pending Confirmation';
export const SCREEN_ID_ADMIN_TOURS_NEEDS_RESCHEDULING = 'Tours Admin - Needs Rescheduling';
export const SCREEN_ID_ADMIN_TOURS_REQUESTED = 'Tours Admin - Requested';
export const SCREEN_ID_ADMIN_TOURS_REQUESTED_RECENTLY_ADDED =
  'Tours Admin - Requested (Recently Added)';
export const SCREEN_ID_ADMIN_TOURS_SCHEDULED = 'Tours Admin - Scheduled';
export const SCREEN_ID_ADMIN_TOURS_SCHEDULED_ADDED_TO_TOUR =
  'Tours Admin - Scheduled (Added to Tour)';
export const SCREEN_ID_ADMIN_TOURS_SCHEDULED_UNASSIGNED = 'Tours Admin - Scheduled (Unassigned)';
export const SCREEN_ID_ADMIN_TOURS_COMPLETED = 'Tours Admin - Completed';
export const SCREEN_ID_ADMIN_TOURS_ALL = 'Tours Admin - All';
export const SCREEN_ID_ADMIN_EDIT_LISTING = 'Admin Edit Listing';
export const SCREEN_ID_ADMIN_PINNED_LISTINGS = 'Pinned Listings Admin';
export const SCREEN_ID_ADMIN_TEST_PUSH_NOTIFICATION = 'Admin Test Push Notification';
export const SCREEN_ID_ADMIN_FRONT_CHANNELS = 'Admin Front Channels';
export const SCREEN_ID_ADMIN_DEPLOYMENTS = 'Admin Deployments';
export const SCREEN_ID_ADMIN_ADD_TO_TOUR = 'Admin Add To Tour';
export const SCREEN_ID_ADMIN_REDIRECTIONS = 'Admin - Redirections';
export const SCREEN_ID_ADMIN_APARTMENT_COMPLEX_UNIT_GROUPS =
  'Admin - Apartment Complex Unit Groups';
export const SCREEN_ID_ADMIN_USER_TOUR_CREATOR = 'Admin - User & Tour Creator';
export const SCREEN_ID_ADMIN_TOUR_TIME_BLOCK_OFF = 'Admin - Tour Time Block-Off';
export const SCREEN_ID_ADMIN_SR_LISTINGS_PAGE = 'Admin SR Listings Page';
export const SCREEN_ID_ADMIN_SR_LISTING_EDIT_PAGE = 'Admin SR Listing Edit Page';
export const SCREEN_ID_ADMIN_HOUSEHOLD_ROUND_ROBIN_ASSIGNMENT_CONTROL =
  'Admin Household Round Robin Assignment Control';
export const SCREEN_ID_ADMIN_TOUR_GUIDE_SCHEDULES = 'Admin - Tour Guide Schedules';
export const SCREEN_ID_ADMIN_TENANT_SCREENING_CRITERIA = 'Admin - Tenant Criteria Requirements';
export const SCREEN_ID_ADMIN_APARTMENTS = 'Admin - Apartments';
export const SCREEN_ID_ADMIN_APARTMENT = 'Admin - Apartment';
export const SCREEN_ID_ADMIN_PARTNER_SALES = 'Admin - Partner Sales';
export const SCREEN_ID_ADMIN_GOING_TO_MARKET = 'Admin - Going To Market';
export const SCREEN_ID_ADMIN_GOING_TO_MARKET_V2 = 'Admin - Going To Market V2';
export const SCREEN_ID_ADMIN_MOVE_INS = 'Admin - Move Ins';
export const SCREEN_ID_ADMIN_RENTLINX_LEAD = 'Admin - Rentlinx Lead';
export const SCREEN_ID_ADMIN_LISTING_VITALS = 'Admin - Listing Vitals';
export const SCREEN_ID_ADMIN_ORDERS_OVERVIEW = 'Admin - Orders Overview';
export const SCREEN_ID_ADMIN_LISTING_ORDERS = 'Admin - Listing Orders';
export const SCREEN_ID_ADMIN_MANUAL_ID_VERIFICATION = 'Admin - Manual ID verification';
export const SCREEN_ID_HITLIST_TASKS = 'Admin - Hitlist Tasks';

export const SCREEN_ID_ADMIN_FINANCE_INVOICES = 'Admin Finance Invoices';
export const SCREEN_ID_ADMIN_FINANCE_LOCATOR_COMMISSION_STRUCTURES =
  'Admin Finance Locator Commission Structures';
export const SCREEN_ID_ADMIN_FINANCE_DEPOSITS = 'Admin Finance Deposits';
export const SCREEN_ID_ADMIN_FINANCE_LEASES = 'Admin Finance Leases';
export const SCREEN_ID_ADMIN_FINANCE_LOCATOR_COMMISSIONS = 'Admin Finance Locator Commissions';

export const SCREEN_ID_SUNLOCKS_DASHBOARD = 'Sunlocks Dashboard';
export const SCREEN_ID_CODEBOX_DASHBOARD = 'Codebox Dashboard';

export const SCREEN_ID_HOUSEHOLD_DASHBOARD_APPLICATION_INITIAL =
  'Household Dashboard - Wants To Apply';
export const SCREEN_ID_HOUSEHOLD_DASHBOARD_APPLICATION_STARTED = 'Household Dashboard - Started';
export const SCREEN_ID_HOUSEHOLD_DASHBOARD_APPLICATION_COMPLETED =
  'Household Dashboard - Completed';
export const SCREEN_ID_HOUSEHOLD_DASHBOARD_APPLICATION_PAID = 'Household Dashboard - Paid';
export const SCREEN_ID_HOUSEHOLD_DASHBOARD_APPLICATION_DELIVERED =
  'Household Dashboard - Delivered';
export const SCREEN_ID_HOUSEHOLD_DASHBOARD_APPLICATION_ACCEPTED = 'Household Dashboard - Accepted';
export const SCREEN_ID_HOUSEHOLD_DASHBOARD_LEASE_SIGNED = 'Household Dashboard - Lease Signed';
export const SCREEN_ID_HOUSEHOLD_DASHBOARD_KANBAN_VIEW = 'Household Dashboard - Kanban View';
export const SCREEN_ID_HOUSEHOLD_DASHBOARD_ALL = 'Household Dashboard - All';

export const SCREEN_ID_AGENT_TOURS = 'Agent Tours';
export const SCREEN_ID_AGENT_MAP = 'Agent Map';
export const SCREEN_ID_AGENT_LEADERBOARD = 'Agent Leaderboard';
export const SCREEN_ID_AGENT_FAILED_SHOWING = 'Agent Failed Showing';

export const SCREEN_ID_APARTMENT_LOCATOR_LEADERBOARD = 'Apartment Locator - Leaderboard';
export const SCREEN_ID_APARTMENT_LOCATOR_PHONE_CALL = 'Apartment Locator - Phone Call';
export const SCREEN_ID_APARTMENT_LOCATOR_LEADS_LIST = 'Apartment Locator - Leads List';
export const SCREEN_ID_APARTMENT_LOCATOR_LEAD = 'Apartment Locator - Lead';
export const SCREEN_ID_APARTMENT_LOCATOR_ADD_LEAD = 'Apartment Locator - Add Lead';
export const SCREEN_ID_APARTMENT_LOCATOR_EDIT_LEAD = 'Apartment Locator - Edit Lead';
export const SCREEN_ID_APARTMENT_LOCATOR_ARCHIVE_LEAD = 'Apartment Locator - Archive Lead';
export const SCREEN_ID_APARTMENT_LOCATOR_LEAD_ACTIVITY = 'Apartment Locator - Lead Activity';
export const SCREEN_ID_APARTMENT_LOCATOR_FEED = 'Apartment Locator - Feed';
export const SCREEN_ID_AGENT_PROFILE = 'Agent - Profile';

export const SCREEN_ID_RENTER_PREQUALIFICATION = 'Renter Prequalification';

export const SCREEN_ID_RENTAL_APPLICATION_AGREEMENT =
  'Rental Application - Renter Requirements Agreement';
export const SCREEN_ID_RENTAL_APPLICATION_CREDIT_INFO = 'Rental Application - Credit Info Form';
export const SCREEN_ID_RENTAL_APPLICATION_PAYMENT = 'Rental Application - Application Fee Payment';
export const SCREEN_ID_RENTAL_APPLICATION_FORM = 'Rental Application - Form';
export const SCREEN_ID_RENTAL_APPLICATION_ADDITIONAL_INFO = 'Rental Application - Additional Info';

export const SCREEN_ID_PARTNER_OVERVIEW = 'Partner Overview';
export const SCREEN_ID_PARTNER_SETTINGS = 'Partner Settings';
export const SCREEN_ID_PARTNER_SETTINGS_SECURITY_DEPOSIT = 'Partner Settings - Security Deposit';
export const SCREEN_ID_PARTNER_SETTINGS_APPLICATIONS = 'Partner Settings - Applications';
export const SCREEN_ID_PARTNER_SETTINGS_LISTING = 'Partner Settings - Listing';
export const SCREEN_ID_PARTNER_SETTINGS_APPROVAL_FLOW = 'Partner Settings - Approval Flow';
export const SCREEN_ID_PARTNER_SETTINGS_ADMIN_SETTINGS = 'Partner Settings - Admin';
export const SCREEN_ID_PARTNER_LISTING = 'Partner Listing';
export const SCREEN_ID_PARTNER_LISTING_EDIT = 'Partner Listing - Edit';
export const SCREEN_ID_PARTNER_LISTING_EDIT_MOVE_IN = 'Partner Listing - Edit Move In';
export const SCREEN_ID_PARTNER_LISTING_EDIT_PROPERTY_DETAILS =
  'Partner Listing - Edit Property Details';
export const SCREEN_ID_PARTNER_LISTING_EDIT_SHOWING_ACCESS =
  'Partner Listing - Edit Showing & Access';
export const SCREEN_ID_PARTNER_LISTING_EDIT_RENTER_PET_CRITERIA =
  'Partner Listing - Edit Renter & Pet Criteria';
export const SCREEN_ID_PARTNER_LISTING_EDIT_FEE_SETTINGS = 'Partner Listing - Edit Fee Settings';
export const SCREEN_ID_PARTNER_LISTING_HOUSEHOLD_APPROVAL = 'Partner Listing - Household Approval';
export const SCREEN_ID_PARTNER_LISTING_HOUSEHOLD_CONNECT_BANK =
  'Partner Listing - Household - Connect Bank';
export const SCREEN_ID_PARTNER_APARTMENT = 'Partner Apartment';
export const SCREEN_ID_PARTNER_MARKET_LISTING_FLOW = 'Partner Market Listing Flow';
export const SCREEN_ID_PARTNER_MARKET_SUNRISE_LISTING_FLOW = 'Partner Market Sunrise Listing Flow';
export const SCREEN_ID_PARTNER_MARKET_LISTING_INVITE_OWNER =
  'Partner Market Listing - Invite Owner';
export const SCREEN_ID_PARTNER_MARKETING_MAKE_LEASING_SIMPLE =
  'Partner Marketing - Make Leasing Simple';
export const SCREEN_ID_PARTNER_BILLING_PAGE = 'Partner Billing';
export const SCREEN_ID_PARTNER_REPORTS = 'Partner Reports';

export const SCREEN_ID_UTILITY_PROFIT_ADMIN = 'Utility Profit Admin';
export const SCREEN_ID_UTILITY_PROFIT_ADMIN_PROCESSING_ACTIVATION =
  'Utility Profit Admin Processing Activation';
export const SCREEN_ID_UTILITY_PROFIT_ADMIN_PROCESSING_ADDRESS =
  'Utility Profit Admin Processing Address';
export const SCREEN_ID_UTILITY_PROFIT_ADMIN_REGISTER_ADDRESS =
  'Utility Profit Admin Register Address';
export const SCREEN_ID_UTILITY_PROFIT_ADMIN_BCC_REMINDERS = 'Utility Profit Admin BCC Reminders';
export const SCREEN_ID_UTILITY_PROFIT_ADMIN_LISTINGS_SCRAPER_LOG_GROUPS =
  'Utility Proit Admin Listings Scraper Log Groups';
export const SCREEN_ID_UTILITY_PROFIT_ADMIN_ACCOUNTING_DASHBOARD =
  'Utility Proit Admin Accounting Dashboard';
export const SCREEN_ID_UTILITY_PROFIT_ADMIN_ACCOUNTING_NON_INTERNET_DASHBOARD =
  'Utility Proit Admin Accounting Non-Internet Dashboard';
export const SCREEN_ID_UTILITY_PROFIT_ADMIN_MAPPING_HITLIST =
  'Utility Profit Admin Mapping Hitlist';
export const SCREEN_ID_UTILITY_PROFIT_ADMIN_ORDER_HITLIST = 'Utility Profit Admin Order Hitlist';
export const SCREEN_ID_UTILITY_PROFIT_ADMIN_PMS_SYNC = 'Utility Profit Admin PMS Sync';
export const SCREEN_ID_UTILITY_PROFIT_ADMIN_PROVIDERS = 'Utility Profit Admin Providers';
export const SCREEN_ID_UTILITY_PROFIT_ADMIN_ADDRESS_RESOLUTION = 'Utility Profit Admin Address Resolution';
export const SCREEN_ID_UTILITY_PROFIT_PARTNER_SIGN_UP = 'Utility Profit Partner Sign Up';
export const SCREEN_ID_UTILITY_PROFIT_LOGIN = 'Utility Profit Login';
export const SCREEN_ID_UTILITY_PARTNER_OVERVIEW = 'Utility Partner Overview';
export const SCREEN_ID_SUNROOM_UTILITY_PARTNER_OVERVIEW = 'Utility SR Partner Overview';
export const SCREEN_ID_UTILITY_PARTNER_SETTINGS = 'Utility Partner Settings';
export const SCREEN_ID_UTILITY_PARTNER_SETTINGS_TEAM = 'Utility Partner Settings - Team';
export const SCREEN_ID_UTILITY_PARTNER_SETTINGS_BILLING = 'Utility Partner Settings - Billing';
export const SCREEN_ID_UTILITY_PARTNER_SETTINGS_TENANT = 'Utility Partner Settings - Tenant';
export const SCREEN_ID_UTILITY_PARTNER_SETTINGS_BANKS = 'Utility Partner Settings - Banks';
export const SCREEN_ID_UTILITY_PARTNER_SETTINGS_PARTNER = 'Utility Partner Settings - Partner';
export const SCREEN_ID_UTILITY_PROFIT_PARTNER_OVERVIEW = 'Utility Profit Partner Overview';
export const SCREEN_ID_UTILITY_PROFIT_PARTNER_REDIRECT = 'Utility Profit Partner Redirect';
export const SCREEN_ID_UTILITY_PROFIT_PARTNER_USER_ACTIVATION =
  'Utility Profit Partner User Activation';
export const SCREEN_ID_UTILITY_PROFIT_ADMIN_AUTOMATIC_ORDERS =
  'Utility Profit Admin Automatic Orders';
export const SCREEN_ID_UTILITY_PROFIT_ADMIN_AUTOMATIC_ORDERS_DETAILS =
  'Utility Profit Admin Automatic Orders Details';
export const SCREEN_ID_UTILITY_PROFIT_PARTNER_REPORTS = 'Utility Profit Partner Reports';

export const SCREEN_ID_UTILITY_RESET_PASSWORD = 'Utility Reset Password';
export const SCREEN_ID_UTILITY_RESET_PASSWORD_VALIDATE_CODE =
  'Utility Reset Password - Validate Code';

export const SCREEN_ID_UTILITY_SETUP_SIGNUP = 'Utility Setup - Signup';
export const SCREEN_ID_UTILITY_SETUP_LOGIN = 'Utility Setup - Login';
export const SCREEN_ID_UTILITY_SETUP_VERIFY_PHONE = 'Utility Setup - Verify Phone';
export const SCREEN_ID_UTILITY_SETUP_OVERVIEW = 'Utility Setup - Overview';
export const SCREEN_ID_UTILITY_SETUP_PROVIDER = 'Utility Setup - Provider';
export const SCREEN_ID_UTILITY_SETUP_PROVIDER_PLAN = 'Utility Setup - Provider Plan';
export const SCREEN_ID_UTILITY_SETUP_NEW_CUSTOMER_DEALS = 'Utility Setup - New Customer Deals';
export const SCREEN_ID_UTILITY_SETUP_PROVIDER_PLAN_NO_CONTRACT =
  'Utility Setup - Provider Plan No Contract';
export const SCREEN_ID_UTILITY_SETUP_PROVIDER_PLAN_CONFIRMATION =
  'Utility Setup - Provider Plan Confirmation';
export const SCREEN_ID_UTILITY_SETUP_PLACE_ORDER = 'Utility Setup - Place Order';
export const SCREEN_ID_UTILITY_SETUP_ADDRESS_SEARCH = 'Utility Setup - Address Search';

export const SCREEN_ID_LOCATOR_TOURS_LANDING_PAGE = 'Locator Tours Landing Page';
export const SCREEN_ID_LOCATOR_TOURS_APARTMENT_PAGE = 'Locator Tours Apartment Page';
export const SCREEN_ID_LOCATOR_TOURS_GUEST_CARD_PAGE = 'Locator Tours Guest Card Page';
export const SCREEN_ID_LOCATOR_TOURS_LOCKBOX_CODE_PAGE = 'Locator Tours Lockbox Code Page';
export const SCREEN_ID_LOCATOR_TOURS_SUCCESS_PAGE = 'Locator Tours Success Page';
export const SCREEN_ID_LOCATOR_TOURS_FEEDBACK_PAGE = 'Locator Tours Feedback Page';

export const SCREEN_TOUR_CONFIRM_IDS = [
  SCREEN_ID_TOUR_CONFIRM_MOVE_IN,
  SCREEN_ID_TOUR_CONFIRM_AVAILABLE_DATE,
  SCREEN_ID_TOUR_CONFIRM_MAX_LEASE_MONTHS,
  SCREEN_ID_TOUR_CONFIRM_FIRST_TIME,
];

export const SCREEN_ID_LEASE_DRAFT_HELPER = 'Lease Draft Helper Page';
export const SCREEN_ID_LEASE_DRAFT_CONFIG = 'Lease Draft Configuration Page';
export const SCREEN_ID_APPLICATION_ASSEMBLY_LINE = 'Application Asssembly Line';

export const SCREEN_ID_SUNSETUP_INVENTORY = 'Sunsetup Inventory';
export const SCREEN_ID_SUNSETUP_DRIVER_ORDERS = 'Sunsetup - Driver Orders';
export const SCREEN_ID_SUNSETUP_DRIVER_ORDER = 'Sunsetup - Driver Order';
export const SCREEN_ID_SUNSETUP_DRIVER_JOB = 'Sunsetup - Driver Job';
export const SCREEN_ID_SUNSETUP_CREATE_ORDER = 'Sunsetup - Create Order';
export const SCREEN_ID_SUNSETUP_UPDATE_ORDER = 'Sunsetup - Update Order';
export const SCREEN_ID_SUNSETUP_ITEM_REGISTER = 'Sunsetup - Item Register';

export const SCREEN_ID_DRIVER_CREATE_ACCOUNT = 'Create Driver Account';

export const SCREEN_ID_PDF_GENERATOR = 'PDF Generator';

/* eslint-enable max-len */
